// unDraw images
// https://undraw.co/illustrations
import img_1 from '../../assets/images/kotoricircle.png'
import img_2 from '../../assets/images/kaishi.png'

export const homeObjOne = {
    id: "about",
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: "",
    headline: "「ことり」とは？",
    description: "子ども達の自立の力を育て、未来につなぐ。\n出来ることを伸ばし、出来ないことは一緒にトライ。\n子ども達自身の力でものごとを進められるように一人ひとりに合った方法で支援します。"　,
    buttonLabel: "詳しくはこちら",
    imgStart: false,
    img: img_1,
    alt: "kotori",
    dark: true,
    primary: true,
    darkText: true,
    btnDisplay: true
}

export const homeObjTwo = {
    id: "overview",
    lightBg: false,
    lightText: false,
    lightTextDesc: false,
    topLine: "",
    headline: "放課後等デイサービスとは",
    description: "児童福祉法に基づき、放課後や学校休業日を利用して、\n子どもたちの学校生活や家庭生活が楽しくなるよう\n支援を行います。\n大勢の中では自分の力を発揮できないお子さんに、\n個別に支援方法を作成し支援します。",
    buttonLabel: "",
    imgStart: false,
    img: img_2,
    alt: "kotori",
    dark: true,
    primary: true,
    darkText: true,
    btnDisplay: false
}

export const homeObjThree = {
    id: "overview",
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: "",
    headline: "管理者プロフィール",
    description: "京都教育大学教育学部幼児教育科卒業\n奈良女子大学大学院人間文化研究科博士\n（人間行動科学専攻）\n大阪市立大学大学院生活科学研究科博士\n（臨床心理学専攻）\n\n小学校教員、中学校教員を経て、個人塾と学研教室を経営。\n特別な支援が必要な生徒と出会い、大学院で人間行動科学と臨床心理学を学ぶ。キャリアコンサルタント国家資格取得。\n若者の就労支援、スクールカウンセラー、放課後等デイサービス児童指導員として子ども達の支援を行う。",
    buttonLabel: "",
    imgStart: false,
    img: img_1,
    alt: "kotori",
    dark: false,
    primary: false,
    darkText: true,
    btnDisplay: false
}